export default __webpack_public_path__ + "static/media/france.66822caa.png";